import "reflect-metadata";
import {QuoteWrapper} from 'quote-domain-core';
import { container } from 'tsyringe';
import { QuoteWrapperService } from './service/quote-wrapper-service';

export class QuoteWrapperManager {
    constructor(private readonly quoteWrapperService: QuoteWrapperService = container.resolve(QuoteWrapperService)) {
    }

    public updateQuoteWrapperColors(quoteWrapper: QuoteWrapper): QuoteWrapper {
        this.quoteWrapperService.updateQuoteWrapperColors(quoteWrapper);
        return quoteWrapper;
    }
}

